
document.addEventListener('click', async (e) => {
  const btn = e.target.closest('[data-quick-add]');
  if (!btn) return;
  const id = btn.getAttribute('data-variant-id');
  if (!id) return;
  btn.disabled = true;
  const old = btn.textContent;
  btn.textContent = 'Adding…';
  try {
    const res = await fetch((window.Shopify?.routes?.root || '/') + 'cart/add.js', {
      method: 'POST',
      headers: {'Content-Type':'application/json'},
      body: JSON.stringify({items:[{id:Number(id),quantity:1}]})
    });
    if (!res.ok) throw new Error('Add failed');
    const cart = await fetch((window.Shopify?.routes?.root || '/') + 'cart.js').then(r=>r.json());
    document.querySelectorAll('[data-cart-count]').forEach(el => el.textContent = cart.item_count);
    btn.textContent = 'Added ✓';
    setTimeout(()=>btn.textContent=old,1300);
  } catch(err) {
    btn.textContent = 'Try again';
    setTimeout(()=>btn.textContent=old,1600);
  } finally { btn.disabled = false; }
});
